import React, { useContext, useState, Fragment, useEffect } from 'react';

import Init from '../../../Init/Init';
import './Winvest.scss';
import PrimaryButton from '../../Utilities/PrimaryButton/PrimaryButton';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    return {
        appRepo: state.appRepo.data
    };
}

const Winvest = (props) => {
    const { winvest } = Init.config.sectionAssets;
    const [ windowsUrl, setWindowsUrl ] = useState("");
    const [ macUrl, setMacUrl ] = useState("");   
    const [ androidUrl, setAndroidUrl ] = useState("");
    const [ iosUrl, setIosUrl ] = useState("");

    useEffect(() => {
        if( props.appRepo.length > 0 ) {
            setWindowsUrl(props.appRepo[2].download_url);
            setMacUrl(props.appRepo[2].download_url);
            setAndroidUrl(props.appRepo[0].download_url);
            setIosUrl(props.appRepo[1].download_url);
        }
    }, [props.appRepo]);

    return (
        <div 
            id="winvest" 
            className="winvest"
            style={{
                backgroundImage: `url(${props.customBg})`,
                backgroundPosition: `center`,
                backgroundSize: `cover`,
                backgroundRepeat: `no-repeat`
            }}
        >
            <div className="winvest-image">
                <img src={`${props.customImage}`} alt="" />
            </div>
            <div className="winvest-section">
                <div className="winvest-header-container">
                    <h2 className='winvest-title'>
                        { props.title }
                    </h2>
                </div>
                <p className="winvest-desc" dangerouslySetInnerHTML={{__html: `${ props.desc }`}}>
                    
                </p>
                <div className="winvest-download-container">
                    {
                        props.showGooglePlay && (
                            <a target="_blank" href={"https://play.google.com/store/apps/details?id=com.waterfrontsekuritas.winvest"}>
                                <img src={winvest.googlePlay} alt="Google Play Store" />
                            </a>
                        )
                    }
                    {
                        props.showAppStore && (
                            <a target="_blank" href={"https://apps.apple.com/us/app/winvest-waterfront-sekuritas/id6752232354"}>
                                <img src={winvest.appStore} alt="Apple App Store" />
                            </a>
                        )
                    }
                    {
                        props.showMacDownload && (
                            <a target="_blank" href={ macUrl }>
                                <img src={ winvest.macos } alt="" />
                            </a>
                        )
                    }
                    {
                        props.showWindowsDownload && (
                            <a target="_blank" href={ windowsUrl }>
                                <img src={ winvest.windows } alt="" />
                            </a>
                        )
                    }
                </div>
                {/* <PrimaryButton 
                    text="Pelajari lebih lanjut"
                    customClass="winvest-btn"
                    href="/"
                /> */}
            </div>
        </div>
    );
}

Winvest.defaultProps = {
    customBg: "",
    customImage: "",
    title: "Download Winvest",
    desc: `Lengkap, cepat, dan terpercaya.
    <br />
    Bersama Winvest, raih pertumbuhan aset Anda!`,
    showGooglePlay: false,
    showAppStore: false,
    showMacDownload: false,
    showWindowsDownload: false,
    showWebsiteLink: false,
}

export default connect(mapStateToProps)(Winvest);